module.exports = __webpack_public_path__ + "img/base-map-img.b2c54463.png";